import { offlineDb } from '../services/offline/OfflineDatabase';
import { CACHE_TTL_MS } from './constants';

export interface CachedTranslations {
  translations: Record<string, string>;
  timestamp: number;
}

export async function getCachedTranslations(
  language: string
): Promise<CachedTranslations | null> {
  try {
    const entry = await offlineDb.getTranslations(language);
    if (!entry) return null;
    return { translations: entry.translations, timestamp: entry.timestamp };
  } catch {
    return null;
  }
}

export function isCacheStale(timestamp: number): boolean {
  return Date.now() - timestamp > CACHE_TTL_MS;
}

export async function setCachedTranslations(
  language: string,
  translations: Record<string, string>
): Promise<void> {
  try {
    await offlineDb.setTranslations(language, translations);
  } catch (err) {
    console.warn('[i18n] Failed to cache translations:', err);
  }
}

export async function invalidateCachedTranslations(
  language?: string
): Promise<void> {
  try {
    if (language) {
      await offlineDb.translations.delete(language);
    } else {
      await offlineDb.clearTranslations();
    }
  } catch (err) {
    console.warn('[i18n] Failed to invalidate cache:', err);
  }
}
